<div class="modal inmodal fade in parcel-modal create-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog"
             [ngClass]="{'decreased-width' : settingsAmenitiesService.selectedItemData.timeSequenceType == 'range'}">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Payments</h4>
                </div>
                <div class="modal-body">
                    <div class="m-b-xs" *ngFor="let fee of fees; let index = index;">
                        <table class="payments-grid-table m-b-sm">
                            <tr class="payments-grid-table-row">
                                <th class="payments-grid-table-header">Active</th>
                                <th class="payments-grid-table-header">Name</th>
                                <th class="payments-grid-table-header">Amount</th>
                                <th class="payments-grid-table-header">Req'd</th>
                                <th class="payments-grid-table-header">Refundable</th>
                                <th class="payments-grid-table-header"
                                     *ngIf="settingsAmenitiesService.selectedItemData.timeSequenceType == 'daily'">
                                    Charge Daily
                                </th>
                                <th class="payments-grid-table-header"
                                     *ngIf="settingsAmenitiesService.selectedItemData.timeSequenceType == 'hourly'">
                                    Charge Hourly
                                </th>
                                <th class="payments-grid-table-header">Can be Waived</th>
                                <th class="payments-grid-table-header"></th>
                            </tr>
                            <tr class="payments-grid-table-row">
                                <td class="payments-grid-table-cell active">
                                    <div class="settings-amenities-slider-container">
                                        <mat-slide-toggle name="feeActive{{index}}"
                                                          [(ngModel)]="fee.active">
                                        </mat-slide-toggle>
                                    </div>
                                </td>
                                <td class="payments-grid-table-cell name">
                                    <input class="form-control" name="feeName{{index}}" [(ngModel)]="fee.name">
                                </td>
                                <td class="payments-grid-table-cell amount">
                                    <input class="form-control"
                                           type="number"
                                           required
                                           name="feeAmount{{index}}"
                                           [(ngModel)]="fee.amount">
                                </td>
                                <td class="payments-grid-table-cell required">
                                    <div class="filter-checkbox">
                                        <label class="img-checkbox">
                                            <input type="checkbox"
                                                   name="fee{{index}}"
                                                   id="fee{{index}}"
                                                   #fee{{index}}
                                                   [(ngModel)]="fee.required">
                                            <label for="fee{{index}}"><svg-checked></svg-checked></label>
                                        </label>
                                    </div>
                                </td>
                                <td class="payments-grid-table-cell refundable">
                                    <div class="filter-checkbox">
                                        <label class="img-checkbox">
                                            <input type="checkbox"
                                                   name="feeRefundable{{index}}"
                                                   id="feeRefundable{{index}}"
                                                   (ngModelChange)="onRefundableChange($event, fee)"
                                                   #feeRefundable{{index}}
                                                   [(ngModel)]="fee.refundable">
                                            <label for="feeRefundable{{index}}"><svg-checked></svg-checked></label>
                                        </label>
                                    </div>
                                </td>
                                <td class="payments-grid-table-cell"
                                     *ngIf="settingsAmenitiesService.selectedItemData.timeSequenceType == 'daily'">
                                    <div class="filter-checkbox">
                                        <label class="img-checkbox">
                                            <input type="checkbox"
                                                   name="feeChargeDaily{{index}}"
                                                   id="feeChargeDaily{{index}}"
                                                   [disabled]="fee.refundable"
                                                   #feeChargeDaily{{index}}
                                                   [(ngModel)]="fee.pmtAtTime">
                                            <label for="feeChargeDaily{{index}}"
                                                   [title]="fee.refundable ? 'Refundable fees can not be charged daily.' : ''">
                                                <svg-checked></svg-checked>
                                            </label>
                                        </label>
                                    </div>
                                </td>
                                <td class="payments-grid-table-cell"
                                     *ngIf="settingsAmenitiesService.selectedItemData.timeSequenceType == 'hourly'">
                                    <div class="filter-checkbox">
                                        <label class="img-checkbox">
                                            <input type="checkbox"
                                                   name="feeChargeHourly{{index}}"
                                                   id="feeChargeHourly{{index}}"
                                                   [disabled]="fee.refundable"
                                                   #feeChargeHourly{{index}}
                                                   [(ngModel)]="fee.pmtHourly">
                                            <label for="feeChargeHourly{{index}}"
                                                   [title]="fee.refundable ? 'Refundable fees can not be charged hourly.' : ''">
                                                <svg-checked></svg-checked>
                                            </label>
                                        </label>
                                    </div>
                                </td>
                                <td class="payments-grid-table-cell">
                                    <div class="filter-checkbox">
                                        <label class="img-checkbox">
                                            <input type="checkbox"
                                                   name="availableWaive{{index}}"
                                                   id="availableWaive{{index}}"
                                                   [(ngModel)]="fee.availableWaive">
                                            <label for="availableWaive{{index}}">
                                                <svg-checked></svg-checked>
                                            </label>
                                        </label>
                                    </div>
                                </td>
                                <td class="payments-grid-table-cell">
                                    <div class="buttons-row">
                                        <button type="button" (click)="addNewFee(index)">
                                            <i class="fa icon-plus pull-right" title="Add"></i>
                                        </button>
                                        <button type="button" (click)="removeFee(index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="row text-center m-t-md m-b-md">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/payment-modal/payment-modal.component.html